<template>
  <v-container fluid tag="section">
     <div  v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <div class="pd-c-12" v-for="(itm, idx) in item" :key="idx">
      <v-row>
        <v-col cols='12' :class="$isMobile ? 'size-13' : ''"><span class="subtitle-1 font-weight-bold primary--text">{{itm.year}}年度</span></v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4' :class="$isMobile ? 'size-13' : ''">
          缴费金额：<span class="font-weight-black">
            {{itm === undefined  ? '' :  itm.annualFee }}
            <span>&nbsp;+&nbsp;{{itm.otherFee}}(其他费用)</span>
          </span>
        </v-col>
        <v-col cols='12' md='4' :class="$isMobile ? 'size-13' : ''">
          缴费时间：<span class="font-weight-black">{{itm === undefined  ? '' :  itm.createTime | formatDate }}</span>
        </v-col>
        <v-col cols='12' md='4' :class="$isMobile ? 'size-13' : ''">
          缴费人员：<span class="font-weight-black">{{itm.createUser === undefined  ? '' :  itm.createUser.name }}</span>
        </v-col>
        <v-col cols='12' md='4' :class="$isMobile ? 'size-13' : ''">
          收据信息：
          <span v-if="itm.costFileName" class="font-weight-black" v-for="(file, index) in itm.costFilePath" :key="index">
            <v-btn class="pl-0" text color="primary" small @click="view(file)">收据{{index+1}}</v-btn>
          </span>
          <span class="font-weight-black">
            <v-btn class="pl-0" text color="primary" v-has="'patent-cost-edit'" @click="yearModal = true" small>上传</v-btn>
          </span>
        </v-col>
        <v-col cols='12' md='8' :class="$isMobile ? 'size-13' : ''">
          备注信息：<span class="font-weight-black">{{itm === undefined  ? '' :  itm.remark }}</span>
        </v-col>
      </v-row>
      <v-divider class="mt-5" v-if="idx + 1 < item.length"></v-divider>
       <base-material-simple-alert
        :show.sync='yearModal'
        title='年费收据补传'
        @on-submit='upoad(itm.id)'
        >
        <template v-slot:content>
          <v-row>
            <v-col>
              <file-upload
                label="收据上传(命名：专利号_年费收据.pdf)"
                outlined
                small-chips
                multiple
                prepend-icon=''
                accept=".pdf"
                :bucket='bucket'
                @on-files='costFileName'
              />
            </v-col>
          </v-row>
          可多选，本次上传将覆盖上次上传信息，请谨慎操作！
        </template>
      </base-material-simple-alert>
    </div>
  </v-container>
</template>

<script>
  import { edit } from '@/api/patent/cost.js'
  import FileUpload from '@/components/oss/Index.vue'

  export default {
    components: {
      FileUpload
    },
    name: 'RecordDetail',
    props: {
      item: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {
        bucket: 'yd-patent',
        yearModal: false,
        form: {
          id: ''
        }
      }
    },
    methods: {
      upoad (id) {
        this.form.id = id
        edit(this.form).then(res => {
          if (res.status === 200) {
            this.yearModal = false
            this.$emit('on-load-data')
            this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
          }
        })
      },
      costFileName (fileNames) {
        let costFileName = ''
        fileNames.forEach(name => {
          costFileName += `${this.bucket}/${name},`
        })
        this.form.costFileName = costFileName.substring(0, costFileName.lastIndexOf(','))
      },
      view (path) {
        if (path) {
          window.open(
            path,
            "_blank"
          );
        }
      }
    }
  }
</script>
